import {buildPreparationLabelData} from './build-label-data'
import {renderLabelAssets} from './label-assets'
import {getTargetVolumes, mapLabelSource, toLabelSettings} from './map-label-source'
import type {LabelTranslate} from './types'
import type {CompoundingResult} from '@cypro/engine/utils'

type LabelSource = Parameters<typeof mapLabelSource>[0]['source']
type StatusLogs = Parameters<typeof mapLabelSource>[0]['statusLogs']
type Settings = Parameters<typeof toLabelSettings>[0]

/**
 * The label of one prescription, with the images react-pdf needs. Shared by the side drawer and the
 * Reports list, so a reprint is the very same document (CY-87).
 */
export async function buildLabelData(input: {
  source: LabelSource
  statusLogs: StatusLogs
  settings: Settings
  targets: CompoundingResult | null
  translate: LabelTranslate
}) {
  const label = buildPreparationLabelData(
    mapLabelSource({
      source: input.source,
      statusLogs: input.statusLogs,
      settings: toLabelSettings(input.settings),
      volumes: getTargetVolumes(input.targets),
    }),
    input.translate
  )

  return {label, assets: await renderLabelAssets(label)}
}
